import React from 'react'

const RoleSearchSkeleton = () => {
    return (
        <div className='mt-8 w-full md:max-w-[45rem] flex-1 mx-auto px-4 pb-4 lg:pb-6 lg:px-6 text-white relative flex flex-col justify-center items-center'>
            {/* Main content container */}
            <div className='w-full flex flex-col p-[2px] rounded-[1.5rem]' style={{
                backgroundImage: `linear-gradient(
                    to right,
                    rgba(64, 106, 255, 0.3) 0%,
                    rgba(64, 106, 255, 1) 56%,
                    rgba(64, 106, 255, 0.3) 100%
                )`
            }}>
                <div className='w-full flex flex-col rounded-[1.5rem] bg-[#0c2346] shadow-[0px_0px_10px_0px_rgba(0,0,0,0.5)] relative overflow-hidden p-6'>
                    
                    {/* Background pattern */}
                    <div 
                        className="absolute inset-0 opacity-40 rounded-[1.5rem] bg-repeat bg-[length:180px_180px]"
                        style={{ 
                            backgroundImage: `url('https://assets.learntube.ai/files/personalise/web.webp')`,
                        }} 
                    />
                    
                    {/* Background overlay */}
                    <div className="absolute inset-0 bg-gradient-to-b from-[rgba(64,106,255,0.15)] to-transparent rounded-[1.5rem]" />
                    
                    {/* Content */}
                    <div className='relative z-10 flex flex-col gap-8'>
                        {/* Header skeleton */}
                        <div className='flex flex-col'>
                            <div className='h-8 w-3/4 bg-gradient-to-r from-[#142d84] to-[#060f2f] rounded-md animate-pulse' />
                        </div>

                        {/* Skills list skeleton */}
                        <div className='flex flex-col gap-2'>
                            {[1, 2, 3, 4, 5].map((index) => (
                                <div
                                    key={index}
                                    className='bg-gradient-to-b from-[#142d84] to-[#060f2f] border-[rgba(64,106,255,0.2)] border border-solid rounded-xl p-3 animate-pulse'
                                >
                                    <div className='flex items-center justify-between w-full'>
                                        <div className='flex items-center gap-3 flex-1 min-w-0'>
                                            {/* Skill indicator dot */}
                                            <div className='relative flex-shrink-0 w-[14px] h-[14px]'>
                                                <div className='absolute inset-[-7.14%] w-4 h-4 rounded-full bg-gradient-to-r from-[#406AFF] to-[#70AEFF] animate-pulse' />
                                            </div>

                                            {/* Skill content */}
                                            <div className='flex flex-col gap-2.5 flex-1 min-w-0'>
                                                <div className='h-4 bg-[#70aeff]/30 rounded animate-pulse' style={{ width: `${Math.random() * 40 + 40}%` }} />
                                                <div className='h-3 bg-[rgba(131,190,255,0.2)] rounded animate-pulse' style={{ width: `${Math.random() * 60 + 60}%` }} />
                                            </div>
                                        </div>

                                        {/* Category badge skeleton */}
                                        {index === 1 || index === 2 || index === 5 ? (
                                            <div className='flex-shrink-0 w-16 h-5 bg-[rgba(255,255,255,0.1)] rounded animate-pulse' />
                                        ) : null}
                                    </div>
                                </div>
                            ))}
                        </div>

                        {/* Start button skeleton */}
                        <div className='flex items-center justify-center gap-2 w-full h-12 rounded-lg bg-[#7FC241]/30 animate-pulse' />
                    </div>
                </div>
            </div>

            {/* Loading indicator */}
            <div className='mt-6 flex flex-col gap-1 items-center justify-center'>
                <p className='font-bold text-[#83BEFF] text-[0.75rem] tracking-[0.6px] uppercase'>
                    Loading skills for your role...
                </p>
                <div className='flex items-center justify-center'>
                    <div className='animate-pulse text-[#83BEFF]'>
                        <div className='w-8 h-8 border-2 border-[#83BEFF] border-t-transparent rounded-full animate-spin'></div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default RoleSearchSkeleton